import { crudService } from '../_services/';
import alerts from '../_components/alerts';

export const logAction = {
    clear,
    getLog,
    getLogUsuario,
    getLogExecucoes,
    getLogExecucoesAndamento
};

function getLog(table, id) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'log/' + table + '/' + id;
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeLogsList(response.data || []));
                alerts.clean();
            })
            .catch((err) => {
                console.error('Erro ao carregar log:', err);
                alerts.clean();
                alerts.error('Erro ao carregar log. Verifique o console para mais detalhes.');
                dispatch(changeLogsList([]));
            });
    };
}

function getLogUsuario(id) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'log/usuario/' + id;
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeLogsList(response.data || []));
                alerts.clean();
            })
            .catch((err) => {
                console.error('Erro ao carregar log de usuário:', err);
                alerts.clean();
                alerts.error('Erro ao carregar log de usuário. Verifique o console para mais detalhes.');
                dispatch(changeLogsList([]));
            });
    };
}

function getLogExecucoes() {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'log/execucoes';
        crudService.get(apiEndpoint)
            .then((response) => {
                const data = response && response.data ? response.data : [];
                dispatch(changeLogsList(data));
                alerts.clean();
            })
            .catch((err) => {
                console.error('Erro ao carregar execuções:', err);
                alerts.clean();
                alerts.error('Erro ao carregar execuções. Verifique o console para mais detalhes.');
                dispatch(changeLogsList([]));
            });
    };
}

function getLogExecucoesAndamento() {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'log/execucoesandamento';
        crudService.get(apiEndpoint)
            .then((response) => {
                const data = response && response.data ? response.data : [];
                dispatch(changeExecucoesAndamento(data));
                alerts.clean();
            })
            .catch((err) => {
                console.error('Erro ao carregar execuções em andamento:', err);
                alerts.clean();
                alerts.error('Erro ao carregar execuções em andamento. Verifique o console para mais detalhes.');
                dispatch(changeExecucoesAndamento([]));
            });
    };
}

function clear() {
    return dispatch => {
        dispatch(changeLogsList([]));
        dispatch(changeExecucoesAndamento([]));
    };
}

export function changeLogsList(log) {
    return {
        type: "FETECHED_ALL_LOG",
        log: log
    }
}

export function changeExecucoesAndamento(execucoesAndamento) {
    return {
        type: "FETECHED_EXECUCOES_ANDAMENTO",
        execucoesAndamento: execucoesAndamento
    }
}